module.exports = __webpack_public_path__ + "img/3.758b8c5c.svg";